import { FC } from "react";
import { useLocation } from "react-router";
import cn from "classnames";
import { ModalState } from "src/hooks/useModal";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "src/hooks/redux";
import { selectCurrentUserState } from "src/redux/currentUser/selector";
import { PATHNAMES } from "src/constants/routes";
import { Link } from "../Link";
import { IMenuItem } from "./types";

const ICON_SIZE = 24;

interface Props extends IMenuItem {
  loginModal: ModalState;
}

export const MobMenuItem: FC<Props> = ({
  title,
  path,
  icon,
  activeIcon = icon,
  loginModal,
}) => {
  const { t } = useTranslation();

  const { pathname } = useLocation();

  const { isAuthorized } = useAppSelector(selectCurrentUserState);

  const isHomePagePath = path === PATHNAMES.HOME;

  const isActive = isHomePagePath ? path === pathname : pathname.includes(path);

  const itemTitle = typeof title === "string" ? title : t(title.i18nKey);

  const ItemIcon = isActive ? activeIcon : icon;

  if (
    (path.includes(PATHNAMES.CABINET) && !isAuthorized) ||
    (path.includes(PATHNAMES.LOGIN) && isAuthorized) ||
    (path.includes(PATHNAMES.REGISTRATION) && isAuthorized)
  ) {
    return null;
  }

  const onItemClick = () => {
    if (path === PATHNAMES.LOGIN && !isAuthorized) {
      loginModal.openModal();
    }
  };

  const isLoginPath = path === PATHNAMES.LOGIN;

  return (
    <div onClick={onItemClick}>
      <Link href={isLoginPath ? "#" : path}>
        <div className="flex flex-col items-center gap-0.5 p-1 group">
          {ItemIcon && (
            <ItemIcon
              className="fill-svg-purple-base group-hover:scale-125"
              width={ICON_SIZE}
              height={ICON_SIZE}
            />
          )}
          <span
            className={cn("text-purple-base text-sm font-medium", {
              "!font-bold": isActive,
            })}
          >
            {itemTitle}
          </span>
        </div>
      </Link>
    </div>
  );
};
